import React from 'react';
import { fmtInches } from './InchesInput';
import { shapeGeometry } from './shapeGeometry';

const TEAL = '#0D9488', INK = '#475569';

const toPath = (ops, X, Y) => ops.map((o) => {
  if (o[0] === 'Z') return 'Z';
  if (o[0] === 'C') return `C ${X(o[1])} ${Y(o[2])} ${X(o[3])} ${Y(o[4])} ${X(o[5])} ${Y(o[6])}`;
  return `${o[0]} ${X(o[1])} ${Y(o[2])}`;
}).join(' ');

// Diagrama da abertura com cotas. compact = só o contorno (miniatura).
export const ShapeDiagram = ({ type, measures = {}, width = 240, height = 150, compact = false, className = '', testId }) => {
  const g = shapeGeometry(type, measures);
  if (!(g.w > 0) || !(g.h > 0)) return null;
  const pad = compact ? 3 : 30;
  const padB = compact ? 3 : 20, padT = compact ? 3 : 18;
  const s = Math.min((width - pad * 2) / g.w, (height - padT - padB) / g.h);
  const ox = (width - g.w * s) / 2;
  const X = (x) => +(ox + x * s).toFixed(1);
  const Y = (y) => +(height - padB - y * s).toFixed(1);
  const dims = compact ? [] : g.dims.filter((d) => d.value > 0);
  const label = (d) => `${fmtInches(d.value)}"`;
  const tick = (x, y, horizontal) => (horizontal ? <line x1={x} y1={y - 3} x2={x} y2={y + 3} stroke={INK} strokeWidth="1" /> : <line x1={x - 3} y1={y} x2={x + 3} y2={y} stroke={INK} strokeWidth="1" />);

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} className={className} data-testid={testId} role="img">
      <path d={toPath(g.outline, X, Y)} fill="rgba(13,148,136,0.10)" stroke={TEAL} strokeWidth={compact ? 1.5 : 2} strokeLinejoin="round" />
      {dims.map((d, i) => {
        const x1 = X(d.x1), y1 = Y(d.y1), x2 = X(d.x2), y2 = Y(d.y2);
        if (d.side === 'bottom' || d.side === 'top') {
          const y = d.side === 'bottom' ? y1 + 10 : y1 - 10;
          return <g key={i} data-testid={testId ? `${testId}-dim-${d.side}` : undefined}><line x1={x1} y1={y} x2={x2} y2={y} stroke={INK} strokeWidth="1" />{tick(x1, y, true)}{tick(x2, y, true)}<text x={(x1 + x2) / 2} y={d.side === 'bottom' ? y + 11 : y - 4} fontSize="10" fontWeight="700" fill={INK} textAnchor="middle" fontFamily="ui-monospace, monospace">{label(d)}</text></g>;
        }
        if (d.side === 'mid') {
          const vertical = x1 === x2;
          return <g key={i} data-testid={testId ? `${testId}-dim-mid` : undefined}><line x1={x1} y1={y1} x2={x2} y2={y2} stroke={TEAL} strokeWidth="1" strokeDasharray="3 3" />{vertical ? <text x={x1 + 4} y={(y1 + y2) / 2} fontSize="10" fontWeight="700" fill={TEAL} fontFamily="ui-monospace, monospace">{label(d)}</text> : <text x={(x1 + x2) / 2} y={y1 - 4} fontSize="10" fontWeight="700" fill={TEAL} textAnchor="middle" fontFamily="ui-monospace, monospace">{label(d)}</text>}</g>;
        }
        const x = d.side === 'left' ? x1 - 10 : x1 + 10;
        return <g key={i} data-testid={testId ? `${testId}-dim-${d.side}` : undefined}><line x1={x} y1={y1} x2={x} y2={y2} stroke={INK} strokeWidth="1" />{tick(x, y1, false)}{tick(x, y2, false)}<text x={d.side === 'left' ? x - 4 : x + 4} y={(y1 + y2) / 2 + 3} fontSize="10" fontWeight="700" fill={INK} textAnchor={d.side === 'left' ? 'end' : 'start'} fontFamily="ui-monospace, monospace">{label(d)}</text></g>;
      })}
    </svg>
  );
};
